export default __webpack_public_path__ + "static/screenshot_snow-c23862ba61612d38625ff4fbd5987c00.png";